import { RentalPartner } from '@/entities/bookings/rental-partner.enum';
import * as yup from 'yup';

export const partnerRentSchema = yup.object({
  rentalPartner: yup.string().oneOf(Object.keys(RentalPartner)).required(),
  comment: yup.string().required(),
});
